import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserIcon, KeyRound } from "lucide-react";
import { api, ApiError } from "@/lib/api";
import { useAuth } from "@/store/auth";
import { useToast } from "@/components/ui/toast";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function Login() {
  const nav = useNavigate();
  const { push } = useToast();
  const { setToken } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.login(username.trim(), password);
      setToken(r.access_token, r.expires_in, r.role, r.username);
      push({ title: "Авторизован", description: `Добро пожаловать, ${r.username}`, variant: "success" });
      nav("/", { replace: true });
    } catch (e) {
      const msg = e instanceof ApiError ? e.message : String(e);
      push({ title: "Не удалось войти", description: msg, variant: "destructive" });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-gradient-to-br from-background via-background to-card p-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/15 text-primary">
            <svg viewBox="0 0 24 24" className="h-6 w-6 fill-current">
              <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.7L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z" />
            </svg>
          </div>
          <div>
            <h1 className="text-2xl font-semibold tracking-tight">TMC</h1>
            <p className="text-sm text-muted-foreground">Telegram multichat console</p>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4 rounded-xl border border-border bg-card p-6 shadow-xl">
          <div>
            <Label htmlFor="username">Логин</Label>
            <div className="mt-1.5 flex">
              <span className="inline-flex items-center rounded-l-md border border-r-0 border-border bg-secondary px-3 text-muted-foreground">
                <UserIcon className="h-4 w-4" />
              </span>
              <Input
                id="username"
                autoFocus
                value={username}
                placeholder="admin"
                onChange={(e) => setUsername(e.target.value)}
                className="rounded-l-none"
              />
            </div>
          </div>

          <div>
            <Label htmlFor="password">Пароль</Label>
            <div className="mt-1.5 flex">
              <span className="inline-flex items-center rounded-l-md border border-r-0 border-border bg-secondary px-3 text-muted-foreground">
                <KeyRound className="h-4 w-4" />
              </span>
              <Input
                id="password"
                type="password"
                value={password}
                placeholder="••••••••"
                onChange={(e) => setPassword(e.target.value)}
                className="rounded-l-none"
              />
            </div>
          </div>

          <Button type="submit" disabled={loading || !username.trim() || !password} className="w-full">
            {loading ? "Вхожу…" : "Войти"}
          </Button>
        </form>
      </div>
    </div>
  );
}
